const singlePropertyTranslations = () => {
  const translationData = {
    welcome: {
      content: {
        imageAlt: {
          en: 'property welcome image',
          fr: 'image de bienvenue de la propriété',
          es: 'imagen de bienvenida a la propiedad',
          nl: 'welkomstafbeelding van de accommodatie'
        },
        bathrooms: {
          en: 'Bathrooms',
          fr: 'Salles de bains',
          es: 'Baños',
          nl: 'Badkamers'
        }
      },
      card: {
        arrive: {
          en: 'arrive',
          fr: 'arrivée',
          es: 'llegar',
          nl: 'aankomen'
        },
        depart: {
          en: 'depart',
          fr: 'départ',
          es: 'salir',
          nl: 'vertrekken'
        },
        guests: {
          en: 'guests',
          fr: 'invités',
          es: 'huéspedes',
          nl: 'gasten'
        },
        beds: {
          en: 'Beds:',
          fr: 'Des lits:',
          es: 'Camas:',
          nl: 'Bedden:'
        },
        bedrooms: {
          en: 'bedrooms',
          fr: 'chambres',
          es: 'dormitorios',
          nl: 'slaapkamers'
        },
        makeReservation: {
          en: 'Make a reservation for',
          fr: 'Faire une réservation pour un',
          es: 'Haga una reserva para la',
          nl: 'Maak een reservering voor een'
        },
        period: {
          en: 'Your period is between',
          fr: 'Vos règles se situent entre',
          es: 'Tu período está entre',
          nl: 'Je menstruatie ligt tussen'
        },
        and: {
          en: 'and',
          fr: 'et',
          es: 'y',
          nl: 'en'
        },
        representing: {
          en: 'representing',
          fr: 'représentant',
          es: 'representando',
          nl: 'vertegenwoordigen'
        },
        nights: {
          en: 'nights.',
          fr: 'nuits.',
          es: 'noches.',
          nl: 'nachten.'
        },
        noGuests: {
          en: 'Number of guests',
          fr: 'Possibilité de chambre',
          es: 'Opción de dormitorio',
          nl: 'Slaapkamer optie'
        },
        continue: {
          en: 'Continue',
          fr: 'Continuer',
          es: 'Continuar',
          nl: 'Doorgaan'
        },
        bedroomOption: {
          en: 'bedroom option',
          fr: 'Possibilité de chambre',
          es: 'Opción de dormitorio',
          nl: 'Slaapkamer optie'
        },
        startingAt: {
          en: 'Starting at',
          fr: 'À partir de',
          es: 'A partir de',
          nl: 'Beginnend om'
        },
        perNight: {
          en: 'per night',
          fr: 'par nuit',
          es: 'por noche',
          nl: 'per nacht'
        },
        minNights: {
          en: 'minimum nights.',
          fr: 'nuits minimum.',
          es: 'noches mínimas.',
          nl: 'minimale nachten.'
        },
        book: {
          en: 'Book this villa',
          fr: 'Réservez cette villa',
          es: 'Reserva esta villa',
          nl: 'Boek deze villa'
        },
        save: {
          en: 'save',
          fr: 'sauvegarder',
          es: 'ahorrar',
          nl: 'redden'
        },
        share: {
          en: 'share',
          fr: 'partager',
          es: 'compartir',
          nl: 'deel'
        },
        emailMessage: {
          en: 'hey I want to share this with you',
          fr: 'hé, je veux partager ça avec toi',
          es: 'oye quiero compartir esto contigo',
          nl: 'hoi ik wil dit met jullie delen'
        },
        inquire: {
          en: 'request more information',
          fr: "demander plus d'informations",
          es: 'pida mas información',
          nl: 'vraag meer informatie aan'
        },
        sold: {
          en: 'Sold',
          fr: 'Vendu',
          es: 'Vendido',
          nl: 'Verkocht'
        },
        freeCar: {
          en: 'Free car',
          fr: 'Voiture gratuite',
          es: 'coche gratis',
          nl: 'Gratis auto'
        },
        freeNight: {
          en: 'Free Night',
          fr: 'Nuit gratuite',
          es: 'Noche libre',
          nl: 'Gratis nacht'
        },
        freeGift: {
          en: 'Free Gift',
          fr: 'Cadeau gratuit',
          es: 'Regalo gratis',
          nl: 'Gratis geschenk'
        },
        interior: {
          en: 'Interior',
          fr: 'Intérieur',
          es: 'Interior',
          nl: 'Interieur'
        },
        exterior: {
          en: 'Exterior',
          fr: 'Extérieur',
          es: 'Exterior',
          nl: 'Buitenkant'
        },
        landsize: {
          en: 'Landsize',
          fr: 'Taille du terrain',
          es: 'Tamaño del terreno',
          nl: 'Landgrootte'
        },
        price: {
          en: 'Price',
          fr: 'Prix',
          es: 'Precio',
          nl: 'Prijs'
        },
        bookingNoLoad: {
          en: 'The booked dates could not be loaded. A form will have to be filled and we will contact you in 24-48 hours.',
          fr: "Les dates réservées n'ont pas pu être chargées. Un formulaire devra être rempli et nous vous contacterons dans les 24 à 48 heures.",
          es: 'No se pudieron cargar las fechas reservadas. Deberá rellenar un formulario y nos pondremos en contacto con usted en 24-48 horas.',
          nl: 'De geboekte data konden niet worden geladen. Er moet een formulier worden ingevuld en wij nemen binnen 24-48 uur contact met u op.'
        },
        accommodation: {
          en: 'Accommodation',
          fr: 'Hébergement',
          es: 'Alojamiento',
          nl: 'Accommodatie'
        },
        taxesFees: {
          en: 'Taxes & Fees',
          fr: 'Taxes et frais',
          es: 'impuestos y pagos',
          nl: 'Belastingen'
        },
        total: {
          en: 'Total',
          fr: 'Total',
          es: 'Total',
          nl: 'Totaal'
        },
        contactDetails: {
          en: 'Contact Details',
          fr: 'Détails du contact',
          es: 'Detalles de contacto',
          nl: 'Contact details'
        },
        lessDays: {
          en: 'You have submitted less days than the minimum for this property. Please fill out this form and we will come back to you with more details.',
          fr: 'Vous avez soumis moins de jours que le minimum pour cette propriété. Veuillez remplir ce formulaire et nous reviendrons vers vous avec plus de détails.',
          es: 'Ha enviado menos días que el mínimo para esta propiedad. Complete este formulario y nos comunicaremos con usted con más detalles.',
          nl: 'U heeft minder dagen ingediend dan het minimum voor deze woning. Vul dit formulier in en wij komen bij u terug met meer details.'
        },
        issueLoading: {
          en: 'We had an issue loading the booked dates. Please fill out the form and we will contact you',
          fr: 'Nous avons eu un problème pour charger les dates réservées. Veuillez remplir le formulaire et nous vous contacterons',
          es: 'Tuvimos un problema al cargar las fechas reservadas. Por favor llena el formulario y nos comunicaremos contigo',
          nl: 'Er is een probleem opgetreden bij het laden van de geboekte data. Vul dan het formulier in en wij nemen contact met u op'
        },
        pricingCalculationError: {
          en: 'Unable to calculate pricing. Please try again or contact us for assistance.',
          fr: "Impossible de calculer le prix. Veuillez réessayer ou nous contacter pour obtenir de l'aide.",
          es: 'No se puede calcular el precio. Inténtelo de nuevo o contáctenos para obtener ayuda.',
          nl: 'Kan prijzen niet berekenen. Probeer het opnieuw of neem contact met ons op voor hulp.'
        },
        download: {
          en: 'Download rate sheet',
          fr: 'Télécharger la grille tarifaire',
          es: 'Descargar hoja de tarifas',
          nl: 'Tarievenblad downloaden'
        },
        form: {
          error: {
            validName: {
              en: 'Please enter valid name',
              fr: 'Veuillez entrer un nom valide',
              es: 'Por favor ingresa un nombre válido',
              nl: 'Voer een geldige naam in'
            },
            requiredFirstName: {
              en: 'The first name field is required',
              fr: 'Le champ prénom est obligatoire',
              es: 'El campo de nombre es obligatorio.',
              nl: 'Het veld voornaam is verplicht'
            },
            requiredLastName: {
              en: 'The last name field is required',
              fr: 'Le champ nom de famille est obligatoire',
              es: 'El campo de apellido es obligatorio',
              nl: 'Het achternaamveld is verplicht'
            },
            validEmail: {
              en: 'This email address is not valid.',
              fr: "Cette adresse e-mail n'est pas valide.",
              es: 'Esta dirección de correo electrónico no es válida.',
              nl: 'Dit e-mailadres is niet geldig.'
            },
            requiredEmail: {
              en: 'The email field is required',
              fr: 'Le champ email est obligatoire',
              es: 'El campo de correo electrónico es obligatorio.',
              nl: 'Het e-mailveld is verplicht'
            },
            requiredFields: {
              en: 'Please fill in the following required fields',
              fr: 'Veuillez remplir les champs obligatoires suivants',
              es: 'Por favor complete los siguientes campos obligatorios',
              nl: 'Vul de volgende verplichte velden in'
            },
            maximumGuestsAllowed: {
              en: 'Maximum {count} guests allowed',
              fr: 'Maximum {count} invités autorisés',
              es: 'Máximo {count} huéspedes permitidos',
              nl: 'Maximaal {count} gasten toegestaan'
            }
          },
          success: {
            title: {
              en: 'Your inquiry was successfully sent!',
              fr: 'Votre demande a été envoyée avec succès!',
              es: '¡Su consulta fue enviada exitosamente!',
              nl: 'Uw aanvraag is succesvol verzonden!'
            },
            subtitle: {
              en: 'One of our representatives will reach out to you shortly.',
              fr: 'Un de nos représentants vous contactera sous peu.',
              es: 'Uno de nuestros representantes se comunicará con usted en breve.',
              nl: 'Een van onze vertegenwoordigers zal binnenkort contact met u opnemen.'
            },
            button: {
              en: 'Browse More Properties',
              fr: 'Parcourir plus de propriétés',
              es: 'Explorar más propiedades',
              nl: 'Blader door meer eigendommen'
            }
          },
          fields: {
            firstName: {
              en: 'First Name:',
              fr: 'Prénom:',
              es: 'Nombre de pila:',
              nl: 'Voornaam:'
            },
            lastName: {
              en: 'Last Name:',
              fr: 'Nom de famille:',
              es: 'Apellido:',
              nl: 'Achternaam:'
            },
            email: {
              en: 'Email Address:',
              fr: 'Adresse e-mail:',
              es: 'Dirección de correo electrónico:',
              nl: 'E-mailadres:'
            },
            phone: {
              en: 'Phone Number (optional):',
              fr: 'Numéro de téléphone (facultatif):',
              es: 'Numero de teléfono (opcional):',
              nl: 'Telefoon nummer (optioneel):'
            },
            message: {
              en: 'Message (optional)',
              fr: 'Message (optionnel)',
              es: 'mensaje (opcional)',
              nl: 'Bericht (optioneel)'
            },
            submit: {
              en: 'send message',
              fr: 'envoyer le message',
              es: 'enviar mensaje',
              nl: 'bericht versturen'
            },
            continue: {
              en: 'Continue',
              fr: 'Continuer',
              es: 'Continuar',
              nl: 'Doorgaan'
            }
          },
          agreement: {
            en: "I agree to be contacted by St Martin Sotheby's Realty",
            fr: "J'accepte d'être contacté par St Martin Sotheby's Realty",
            es: "Acepto ser contactado por St Martin Sotheby's Realty",
            nl: "Ik ga ermee akkoord dat St Martin Sotheby's Realty contact met mij opneemt"
          }
        },
        stripe: {
          paymentDetails: {
            en: 'Payment Details',
            fr: 'Détails de paiement',
            es: 'Detalles del pago',
            nl: 'Betalingsdetails'
          },
          error: {
            en: 'There was an error. Please try again !',
            fr: 'Il y avait une erreur. Veuillez réessayer !',
            es: 'Hubo un error. Inténtalo de nuevo !',
            nl: 'Er is een fout opgetreden. Probeer het opnieuw!'
          },
          confirming: {
            en: 'Confirming Card',
            fr: 'Carte de confirmation',
            es: 'Tarjeta de confirmación',
            nl: 'Kaart bevestigen'
          },
          confirm: {
            en: 'Confirm Card',
            fr: 'Confirmer la carte',
            es: 'Confirmar tarjeta',
            nl: 'Bevestig kaart'
          },
          calculating: {
            en: 'Calculating pricing...',
            fr: 'Calcul des prix...',
            es: 'Calculando precios...',
            nl: 'Prijzen berekenen...'
          },
          processingPayment: {
            en: 'Processing payment...',
            fr: 'Traitement du paiement...',
            es: 'Procesando pago...',
            nl: 'Betaling verwerken...'
          },
          creatingReservation: {
            en: 'Creating reservation...',
            fr: 'Création de la réservation...',
            es: 'Creando reserva...',
            nl: 'Reservering maken...'
          },
          sendingConfirmation: {
            en: 'Sending confirmation...',
            fr: 'Envoi de la confirmation...',
            es: 'Enviando confirmación...',
            nl: 'Bevestiging verzenden...'
          },
          tryAgain: {
            en: 'Try Again',
            fr: 'Réessayer',
            es: 'Intentar de nuevo',
            nl: 'Probeer opnieuw'
          },
          paymentFailed: {
            en: 'Payment Failed',
            fr: 'Paiement échoué',
            es: 'Pago fallido',
            nl: 'Betaling mislukt'
          },
          paymentFailedMessage: {
            en: 'Your payment could not be processed. Please check your card details and try again.',
            fr: "Votre paiement n'a pas pu être traité. Veuillez vérifier les détails de votre carte et réessayer.",
            es: 'No se pudo procesar su pago. Verifique los detalles de su tarjeta e intente nuevamente.',
            nl: 'Uw betaling kon niet worden verwerkt. Controleer uw kaartgegevens en probeer het opnieuw.'
          },
          reservationPending: {
            en: 'Processing Your Booking',
            fr: 'Traitement de votre réservation',
            es: 'Procesando su reserva',
            nl: 'Uw boeking verwerken'
          },
          reservationPendingMessage: {
            en: "Your payment was successful. We're processing your reservation and you'll receive confirmation within 15 minutes.",
            fr: 'Votre paiement a été effectué avec succès. Nous traitons votre réservation et vous recevrez une confirmation dans les 15 minutes.',
            es: 'Su pago fue exitoso. Estamos procesando su reserva y recibirá la confirmación dentro de 15 minutos.',
            nl: 'Uw betaling is gelukt. We verwerken uw reservering en u ontvangt binnen 15 minuten een bevestiging.'
          },
          networkError: {
            en: 'Connection Issue',
            fr: 'Problème de connexion',
            es: 'Problema de conexión',
            nl: 'Verbindingsprobleem'
          },
          networkErrorMessage: {
            en: "We're having trouble connecting. Please check your internet connection and try again.",
            fr: 'Nous avons des difficultés à nous connecter. Veuillez vérifier votre connexion Internet et réessayer.',
            es: 'Estamos teniendo problemas para conectarnos. Verifique su conexión a Internet e intente nuevamente.',
            nl: 'We hebben problemen met verbinden. Controleer uw internetverbinding en probeer het opnieuw.'
          },
          unknownError: {
            en: 'Something Went Wrong',
            fr: 'Quelque chose a mal tourné',
            es: 'Algo salió mal',
            nl: 'Er is iets misgegaan'
          },
          unknownErrorMessage: {
            en: 'An unexpected error occurred. Please try again or contact reservations@sxmsir.com.',
            fr: "Une erreur inattendue s'est produite. Veuillez réessayer ou contacter reservations@sxmsir.com.",
            es: 'Ocurrió un error inesperado. Por favor, inténtelo de nuevo o póngase en contacto con reservations@sxmsir.com.',
            nl: 'Er is een onverwachte fout opgetreden. Probeer het opnieuw of neem contact op met reservations@sxmsir.com.'
          },
          loadingPayment: {
            en: 'Loading payment form...',
            fr: 'Chargement du formulaire de paiement...',
            es: 'Cargando formulario de pago...',
            nl: 'Betalingsformulier laden...'
          },
          paymentUnclear: {
            en: 'Payment Status Unclear',
            fr: 'Statut de paiement incertain',
            es: 'Estado de pago incierto',
            nl: 'Betalingsstatus onduidelijk'
          },
          paymentUnclearMessage: {
            en: 'We are verifying your payment. Please do not retry. You will receive confirmation within 15 minutes. If you do not receive confirmation, please contact reservations@sxmsir.com.',
            fr: 'Nous vérifions votre paiement. Veuillez ne pas réessayer. Vous recevrez une confirmation dans les 15 minutes. Si vous ne recevez pas de confirmation, veuillez contacter reservations@sxmsir.com.',
            es: 'Estamos verificando su pago. Por favor no intente de nuevo. Recibirá confirmación en 15 minutos. Si no recibe confirmación, póngase en contacto con reservations@sxmsir.com.',
            nl: 'We verifiëren uw betaling. Probeer het alstublieft niet opnieuw. U ontvangt binnen 15 minuten een bevestiging. Als u geen bevestiging ontvangt, neem dan contact op met reservations@sxmsir.com.'
          },
          supportText: {
            en: 'Need help? Contact our support team:',
            fr: "Besoin d'aide ? Contactez notre équipe d'assistance :",
            es: '¿Necesitas ayuda? Contacta a nuestro equipo de soporte:',
            nl: 'Hulp nodig? Neem contact op met ons ondersteuningsteam:'
          },
          contactSupport: {
            en: 'Contact Support',
            fr: 'Contacter le support',
            es: 'Contactar soporte',
            nl: 'Neem contact op met ondersteuning'
          },
          note: {
            en: '<br />When using the credit card, there is an additional 2% credit card fee.<br />We will contact you to confirm this booking. If arrival is 60+ days away, only a 25% downpayment is required for confirmation',
            fr: '<br />Lors de l&#39;utilisation de la carte de crédit, des frais supplémentaires de 2 % sont facturés.<br /> Nous vous contacterons pour confirmer cette réservation. Si l&#39;arrivée est prévue dans plus de 60 jours, seul un acompte de 25 % est requis pour la confirmation.',
            es: '<br />Al utilizar la tarjeta de crédito, se aplica un cargo adicional del 2 %.<br /> Nos pondremos en contacto con usted para confirmar esta reserva. Si faltan más de 60 días para la llegada, solo se requiere un pago inicial del 25 % para la confirmación.',
            nl: '<br />Bij gebruik van de creditcard wordt een extra creditcardtoeslag van 2% in rekening gebracht.<br /> Wij nemen contact met u op om deze boeking te bevestigen. Als de aankomst meer dan 60 dagen duurt, is ter bevestiging slechts een aanbetaling van 25% vereist'
          },
          paymentSucceeded: {
            en: 'Payment succeeded!',
            fr: 'Paiement réussi !',
            es: '¡Pago exitoso!',
            nl: 'Betaling gelukt!'
          },
          skip: {
            en: 'Skip paying with card',
            fr: 'Évitez de payer par carte',
            es: 'Evita pagar con tarjeta',
            nl: 'Betalen met kaart overslaan'
          },
          skipNote: {
            en: 'If you choose to skip paying with a card, we will contact you to discuss the payment method and other details.',
            fr: "Si vous choisissez de ne pas payer avec une carte, nous vous contacterons pour discuter du mode de paiement et d'autres détails.",
            es: 'Si elige omitir el pago con tarjeta, nos comunicaremos con usted para analizar el método de pago y otros detalles.',
            nl: 'Als u ervoor kiest om het betalen met een kaart over te slaan, nemen wij contact met u op om de betaalmethode en andere details te bespreken.'
          },
          processingPaymentWarning: {
            en: 'Your payment is being processed. Are you sure you want to leave? This may result in a payment without a confirmed reservation.',
            fr: 'Votre paiement est en cours de traitement. Êtes-vous sûr de vouloir partir? Cela peut entraîner un paiement sans réservation confirmée.',
            es: 'Su pago se está procesando. ¿Estás seguro de que quieres irte? Esto puede resultar en un pago sin una reserva confirmada.',
            nl: 'Uw betaling wordt verwerkt. Weet u zeker dat u wilt vertrekken? Dit kan resulteren in een betaling zonder bevestigde reservering.'
          },
          reservationFailed: {
            en: 'Processing Your Booking',
            fr: 'Traitement de votre réservation',
            es: 'Procesando su reserva',
            nl: 'Uw boeking verwerken'
          },
          reservationFailedMessage: {
            en: 'We encountered an issue creating your reservation. Please try again.',
            fr: 'Nous avons rencontré un problème lors de la création de votre réservation. Veuillez réessayer.',
            es: 'Encontramos un problema al crear su reserva. Por favor, inténtelo de nuevo.',
            nl: 'We zijn een probleem tegengekomen bij het maken van uw reservering. Probeer het alstublieft opnieuw.'
          },
          paymentSucceededNote: {
            en: 'Good news: Your payment was successful. We can try creating your reservation again.',
            fr: 'Bonne nouvelle : votre paiement a été effectué avec succès. Nous pouvons essayer de créer à nouveau votre réservation.',
            es: 'Buenas noticias: Su pago fue exitoso. Podemos intentar crear su reserva nuevamente.',
            nl: 'Goed nieuws: uw betaling is gelukt. We kunnen proberen uw reservering opnieuw aan te maken.'
          },
          retryReservation: {
            en: 'Retry Reservation',
            fr: 'Réessayer la réservation',
            es: 'Reintentar reserva',
            nl: 'Reservering opnieuw proberen'
          },
          connectionTimeout: {
            en: 'Connection Timeout',
            fr: 'Délai de connexion dépassé',
            es: 'Tiempo de espera de conexión',
            nl: 'Verbindingstime-out'
          },
          connectionTimeoutMessage: {
            en: 'This is usually a temporary network issue. Please check your internet connection and try again.',
            fr: "Il s'agit généralement d'un problème de réseau temporaire. Veuillez vérifier votre connexion Internet et réessayer.",
            es: 'Este suele ser un problema de red temporal. Verifique su conexión a Internet e intente nuevamente.',
            nl: 'Dit is meestal een tijdelijk netwerkprobleem. Controleer uw internetverbinding en probeer het opnieuw.'
          },
          serverTimeout: {
            en: 'Server Timeout',
            fr: 'Délai du serveur dépassé',
            es: 'Tiempo de espera del servidor',
            nl: 'Server time-out'
          },
          serverTimeoutMessage: {
            en: 'Our servers are taking longer than expected to respond. Please wait a few minutes and contact reservations@sxmsir.com if the issue persists.',
            fr: 'Nos serveurs mettent plus de temps que prévu à répondre. Veuillez patienter quelques minutes et contacter reservations@sxmsir.com si le problème persiste.',
            es: 'Nuestros servidores tardan más de lo esperado en responder. Espere unos minutos y comuníquese con reservations@sxmsir.com si el problema persiste.',
            nl: 'Onze servers doen er langer over dan verwacht om te reageren. Wacht een paar minuten en neem contact op met reservations@sxmsir.com als het probleem aanhoudt.'
          },
          rateLimitTitle: {
            en: 'Please Wait',
            fr: "S'il vous plaît, attendez",
            es: 'Por favor espera',
            nl: 'Even geduld'
          },
          rateLimitMessage: {
            en: 'Please wait a moment and try again. We received too many requests in a short time.',
            fr: 'Veuillez patienter un instant et réessayer. Nous avons reçu trop de demandes en peu de temps.',
            es: 'Espere un momento e intente nuevamente. Recibimos demasiadas solicitudes en poco tiempo.',
            nl: 'Wacht even en probeer het opnieuw. We ontvingen te veel verzoeken in korte tijd.'
          },
          referenceId: {
            en: 'Reference ID',
            fr: 'ID de référence',
            es: 'ID de referencia',
            nl: 'Referentie-ID'
          },
          datesUnavailable: {
            en: 'Dates No Longer Available',
            fr: 'Dates plus disponibles',
            es: 'Fechas ya no disponibles',
            nl: 'Data niet meer beschikbaar'
          },
          datesUnavailableMessage: {
            en: 'The selected dates are no longer available for booking. Please choose different dates and try again.',
            fr: 'Les dates sélectionnées ne sont plus disponibles pour la réservation. Veuillez choisir des dates différentes et réessayer.',
            es: 'Las fechas seleccionadas ya no están disponibles para reservar. Por favor, elija fechas diferentes e intente nuevamente.',
            nl: 'De geselecteerde data zijn niet meer beschikbaar voor boeking. Kies alstublieft andere data en probeer het opnieuw.'
          },
          validationError: {
            en: 'Required Fields Missing',
            fr: 'Champs obligatoires manquants',
            es: 'Campos obligatorios faltantes',
            nl: 'Verplichte velden ontbreken'
          },
          bookingConfirmation: {
            en: 'Booking Confirmation',
            fr: 'Confirmation de réservation',
            es: 'Confirmación de reserva',
            nl: 'Boekingsbevestiging'
          },
          propertyName: {
            en: 'Property',
            fr: 'Propriété',
            es: 'Propiedad',
            nl: 'Eigendom'
          },
          checkIn: {
            en: 'Check-in',
            fr: 'Arrivée',
            es: 'Entrada',
            nl: 'Inchecken'
          },
          checkOut: {
            en: 'Check-out',
            fr: 'Départ',
            es: 'Salida',
            nl: 'Uitchecken'
          },
          totalPaid: {
            en: 'Total Paid',
            fr: 'Total payé',
            es: 'Total pagado',
            nl: 'Totaal betaald'
          },
          depositReserved: {
            en: 'Deposit Reserved',
            fr: 'Dépôt réservé',
            es: 'Depósito reservado',
            nl: 'Aanbetaling gereserveerd'
          },
          depositNote: {
            en: '(will be charged upon confirmation)',
            fr: '(sera facturé lors de la confirmation)',
            es: '(se cobrará al confirmar)',
            nl: '(wordt in rekening gebracht bij bevestiging)'
          },
          confirmationNumber: {
            en: 'Confirmation Number',
            fr: 'Numéro de confirmation',
            es: 'Número de confirmación',
            nl: 'Bevestigingsnummer'
          },
          emailSent: {
            en: 'A confirmation email has been sent to your email address.',
            fr: 'Un email de confirmation a été envoyé à votre adresse email.',
            es: 'Se ha enviado un correo electrónico de confirmación a su dirección de correo electrónico.',
            nl: 'Er is een bevestigingsmail verzonden naar uw e-mailadres.'
          }
        },
        popup: {
          arrival: {
            en: 'Arrival',
            fr: 'Arrivée',
            es: 'Llegada',
            nl: 'Aankomst'
          },
          departure: {
            en: 'Departure',
            fr: 'Départ',
            es: 'Partida',
            nl: 'Vertrek'
          },
          bedroom: {
            en: 'Bedroom',
            fr: 'Chambre à coucher',
            es: 'Dormitorio',
            nl: 'Slaapkamer'
          },
          guests: {
            en: 'Guests',
            fr: 'Invités',
            es: 'Huéspedes',
            nl: 'Gasten'
          },
          bonuses: {
            en: 'Bonuses',
            fr: 'Bonus',
            es: 'Bonificaciones',
            nl: 'Bonussen'
          },
          freeNight: {
            en: 'Free Nights Bonus',
            fr: 'Bonus de nuits gratuites',
            es: 'Bono de Noches Gratis',
            nl: 'Gratis nachtenbonus'
          },
          total: {
            en: 'Total',
            fr: 'Total',
            es: 'Total',
            nl: 'Totaal'
          },
          coupon: {
            en: 'Coupon',
            fr: 'Coupon',
            es: 'Cupón',
            nl: 'Coupon'
          },
          applyCoupon: {
            en: 'Apply',
            fr: 'Appliquer',
            es: 'Aplicar',
            nl: 'Toepassen'
          },
          taxesFees: {
            en: 'Taxes and Fees',
            fr: 'Taxes et frais',
            es: 'Impuestos y honorarios',
            nl: 'Belastingen en heffingen'
          },
          finalPrice: {
            en: 'Final Price',
            fr: 'Prix final',
            es: 'Precio final',
            nl: 'Uiteindelijke prijs'
          },
          contact: {
            en: 'We will contact you, and upon receiving your confirmation, a 25% charge will be applied',
            fr: 'Nous vous contacterons et après confirmation, les frais ne seront que de 25 %',
            es: 'Nos pondremos en contacto con usted y, al recibir su confirmación, se aplicará un cargo del 25%',
            nl: 'Wij nemen contact met u op en na ontvangst van uw bevestiging wordt een bedrag van 25% in rekening gebracht'
          },
          oldPrice: {
            en: 'Old Price',
            fr: 'Ancien prix',
            es: 'Precio anterior',
            nl: 'Oude prijs'
          },
          subtotal: {
            en: 'Subtotal',
            fr: 'Sous-total',
            es: 'Subtotal',
            nl: 'Subtotaal'
          },
          night: {
            en: 'night',
            fr: 'nuit',
            es: 'noche',
            nl: 'nacht'
          },
          nights: {
            en: 'nights',
            fr: 'nuits',
            es: 'noches',
            nl: 'nachten'
          },
          free: {
            en: 'free',
            fr: 'gratuit',
            es: 'gratis',
            nl: 'vrij'
          },
          invalidCoupon: {
            en: 'Invalid Coupon',
            fr: 'Coupon invalide',
            es: 'Cupón no válido',
            nl: 'Ongeldige kortingsbon'
          },
          networkError: {
            en: 'Network error. Please check your connection and try again.',
            fr: 'Erreur réseau. Veuillez vérifier votre connexion et réessayer.',
            es: 'Error de red. Verifique su conexión e intente nuevamente.',
            nl: 'Netwerkfout. Controleer uw verbinding en probeer het opnieuw.'
          },
          generalError: {
            en: 'Unable to apply coupon. Please try again.',
            fr: "Impossible d'appliquer le coupon. Veuillez réessayer.",
            es: 'No se puede aplicar el cupón. Inténtalo de nuevo.',
            nl: 'Kan coupon niet toepassen. Probeer het opnieuw.'
          }
        },
        thankYou: {
          title: {
            en: 'Thank you for booking with us!',
            fr: "Merci d'avoir réservé avec nous!",
            es: '¡Gracias por reservar con nosotros!',
            nl: 'Bedankt voor uw boeking bij ons!'
          },
          subtitle: {
            en: 'Please tell our Guest Experience team more about your vacation plans.',
            fr: 'Veuillez informer notre équipe Expérience client de vos projets de vacances.',
            es: 'Cuéntele a nuestro equipo de Experiencia del huésped más información sobre sus planes de vacaciones.',
            nl: 'Vertel ons Guest Experience-team meer over uw vakantieplannen.'
          },
          phoneNumber: {
            en: 'Phone Number',
            fr: 'Numéro de téléphone',
            es: 'Número de teléfono',
            nl: 'Telefoonnummer'
          },
          yes: {
            en: 'Yes',
            fr: 'Oui',
            es: 'Sí',
            nl: 'Ja'
          },
          no: {
            en: 'No',
            fr: 'Non',
            es: 'No',
            nl: 'Nee'
          },
          unknown: {
            en: 'unknown',
            fr: 'inconnu',
            es: 'desconocido',
            nl: 'onbekend'
          },
          rentCar: {
            en: 'Do you need to rent a car?',
            fr: 'Avez-vous besoin de louer une voiture ?',
            es: '¿Necesitas alquilar un coche?',
            nl: 'Moet u een auto huren?'
          },
          rentCarNote: {
            en: "Should you choose to rent a car and transfer services through Sotheby's Realty, your car rental will be delivered to the villa for your convenience and sign-up will take place on arrival at the villa.",
            fr: "Si vous choisissez de louer une voiture et des services de transfert via Sotheby's Realty, votre voiture de location sera livrée à la villa pour votre commodité et l'inscription aura lieu à votre arrivée à la villa.",
            es: "Si decide alquilar un coche y servicios de transferencia a través de Sotheby's Realty, el coche de alquiler se entregará en la villa para su comodidad y el registro se realizará a su llegada a la villa.",
            nl: "Als u ervoor kiest om een auto en transferdiensten te huren via Sotheby's Realty, wordt uw huurauto voor uw gemak bij de villa afgeleverd en vindt de aanmelding plaats bij aankomst in de villa."
          },
          transport: {
            en: 'Do you need transporation from the airport?',
            fr: "Avez-vous besoin d'un transport depuis l'aéroport ?",
            es: '¿Necesitas transporte desde el aeropuerto?',
            nl: 'Heeft u vervoer nodig vanaf het vliegveld?'
          },
          transportNote: {
            en: 'We provide a complimentary arrival transfer from the airport to your villa.',
            fr: "Nous proposons un transfert gratuit à l'arrivée de l'aéroport à votre villa.",
            es: 'Ofrecemos un traslado de llegada de cortesía desde el aeropuerto a su villa.',
            nl: 'Wij bieden een gratis aankomsttransfer van de luchthaven naar uw villa.'
          },
          assistance: {
            en: 'Would you like assistance planning activities to create your perfect itinerary?',
            fr: 'Souhaitez-vous de l’aide pour planifier des activités afin de créer votre itinéraire parfait ?',
            es: '¿Le gustaría recibir ayuda para planificar actividades y crear su itinerario perfecto?',
            nl: 'Wilt u hulp bij het plannen van activiteiten om uw perfecte reisschema samen te stellen?'
          },
          assistanceNote: {
            en: 'We provide a complimentary arrival transfer from the airport to your villa.',
            fr: "Nous proposons un transfert gratuit à l'arrivée de l'aéroport à votre villa.",
            es: 'Ofrecemos un traslado de llegada de cortesía desde el aeropuerto a su villa.',
            nl: 'Wij bieden een gratis aankomsttransfer van de luchthaven naar uw villa.'
          },
          food: {
            en: 'Would you like to have the villa pre-stocked with Food and Beverages prior to arrival?',
            fr: 'Souhaitez-vous que la villa soit pré-approvisionnée en nourriture et en boissons avant votre arrivée ?',
            es: '¿Le gustaría tener la villa abastecida previamente con alimentos y bebidas antes de su llegada?',
            nl: 'Wilt u dat de villa voor aankomst wordt gevuld met eten en drinken?'
          },
          foodNote: {
            en: 'Do you need any restaurant recommendation or need help with the reservations?',
            fr: "Avez-vous besoin d'une recommandation de restaurant ou d'aide pour les réservations ?",
            es: '¿Necesitas alguna recomendación de restaurante o necesitas ayuda con las reservas?',
            nl: 'Heeft u een restaurantaanbeveling nodig of heeft u hulp nodig bij het reserveren?'
          },
          submit: {
            en: 'Submit to guest experience',
            fr: "Soumettre à l'expérience client",
            es: 'Enviar a la experiencia del huésped',
            nl: 'Verzenden naar gastervaring'
          }
        },
        skip: {
          title1: {
            en: 'Thank you for your inquiry',
            fr: 'Merci pour votre demande',
            es: 'Gracias por su consulta',
            nl: 'Bedankt voor uw aanvraag'
          },
          title2: {
            en: 'Thank you for booking with us!',
            fr: "Merci d'avoir réservé avec nous!",
            es: '¡Gracias por reservar con nosotros!',
            nl: 'Bedankt voor uw boeking bij ons!'
          },
          subtitle1: {
            en: 'Please check your email, we will respond within 24 to 48 hours',
            fr: 'Veuillez vérifier votre email, nous vous répondrons dans les 24 à 48 heures',
            es: 'Por favor revisa tu correo electrónico, te responderemos dentro de 24 a 48 horas',
            nl: 'Controleer uw e-mail, wij reageren binnen 24 tot 48 uur'
          },
          subtitle2: {
            en: 'Please check your email for your booking confirmation.',
            fr: 'Veuillez vérifier votre courrier électronique pour votre confirmation de réservation.',
            es: 'Por favor revise su correo electrónico para confirmar su reserva.',
            nl: 'Controleer uw e-mail voor uw boekingsbevestiging.'
          },
          questions: {
            en: 'If you have any questions or would like to already start planning your vacation feel free to reach out directly:',
            fr: "Si vous avez des questions ou si vous souhaitez déjà commencer à planifier vos vacances, n'hésitez pas à nous contacter directement :",
            es: 'Si tiene alguna pregunta o desea comenzar a planificar sus vacaciones, no dude en comunicarse directamente:',
            nl: 'Als u vragen heeft of al wilt beginnen met het plannen van uw vakantie, neem dan gerust rechtstreeks contact op met:'
          },
          button: {
            en: 'visit our guest experience page',
            fr: 'visitez notre page expérience client',
            es: 'visita nuestra página de experiencia del huésped',
            nl: 'bezoek onze gastervaringspagina'
          }
        }
      }
    },
    introduction: {
      back: {
        en: 'Back',
        fr: 'Dos',
        es: 'Atrás',
        nl: 'Rug'
      },
      renting: {
        en: 'renting',
        fr: 'location',
        es: 'alquiler',
        nl: 'huren'
      },
      askAbout: {
        en: 'Ask me about',
        fr: 'contactez-moi à propos de cette',
        es: 'Preguntame sobre',
        nl: 'Vraag me over'
      },
      readMore: {
        en: 'Read More',
        fr: 'En savoir plus',
        es: 'Leer más',
        nl: 'Lees verder'
      },
      readLess: {
        en: 'Read Less',
        fr: 'Lire moins',
        es: 'Leer menos',
        nl: 'Lees minder'
      },
      buying: {
        en: 'Buying',
        fr: "l'achat",
        es: 'Comprar',
        nl: 'Kopen'
      },
      options: {
        en: 'Options',
        fr: 'Possibilités',
        es: 'Opciones',
        nl: 'Opties'
      },
      about: {
        en: 'About',
        fr: 'À propos',
        es: 'Acerca de',
        nl: 'Over'
      }
    },
    updates: {
      title: {
        en: 'Updates',
        fr: 'Mises à jour',
        es: 'Actualizaciones',
        nl: 'Updates'
      },
      documents: {
        en: 'Documents Update',
        fr: 'Mise à jour des documents',
        es: 'Actualización de documentos',
        nl: 'Documenten bijwerken'
      }
    },
    gallery: {
      browse: {
        en: 'browse photos and videos',
        fr: 'parcourir les photos et les vidéos',
        es: 'buscar fotos y videos',
        nl: "door foto's en video's bladeren"
      },
      download: {
        en: 'Download images',
        fr: 'Télécharger des images',
        es: 'Descargar imágenes',
        nl: 'Afbeeldingen downloaden'
      },
      next: {
        en: 'Next',
        fr: 'Suivant',
        es: 'Próximo',
        nl: 'Volgende'
      },
      previous: {
        en: 'Previous',
        fr: 'Précédent',
        es: 'Anterior',
        nl: 'Vorig'
      }
    },
    details: {
      title: {
        en: 'Sleeping Arrangements / Bathrooms',
        fr: 'Couchages / Salles de bain',
        es: 'Disposiciones para dormir/baños',
        nl: 'Slaapplaatsen / Badkamers'
      },
      bedroomOptions: {
        en: 'See more bedroom options',
        fr: "Voir plus d'options de chambres",
        es: 'Ver más opciones de dormitorios',
        nl: 'Bekijk meer slaapkameropties'
      },
      commonArea: {
        en: 'Common areas',
        fr: 'Espaces communs',
        es: 'Áreas comunes',
        nl: 'Gemeenschappelijke ruimtes'
      }
    },
    amenities: {
      title: {
        en: 'Amenities Available to You',
        fr: 'Commodités à votre disposition',
        es: 'Servicios disponibles para usted',
        nl: 'Voorzieningen die voor u beschikbaar zijn'
      },
      bathrooms: {
        en: 'Bathrooms',
        fr: 'Salles de bains',
        es: 'Baños',
        nl: 'Badkamers'
      },
      room: {
        en: 'This room has',
        fr: 'Cette chambre a',
        es: 'Esta habitación tiene',
        nl: 'Deze kamer heeft'
      },
      and: {
        en: 'and',
        fr: 'et',
        es: 'y',
        nl: 'En'
      },
      realEstateTitle: {
        en: 'Details, Amenities and Features',
        fr: 'Détails, commodités et fonctionnalités',
        es: 'Detalles, comodidades y características',
        nl: 'Details, voorzieningen en functies'
      },
      moreInformation: {
        en: 'More Information',
        fr: "Plus d'information",
        es: 'Más información',
        nl: 'Meer informatie'
      },
      listingDetails: {
        en: 'Listing Details',
        fr: "Détails de l'annonce",
        es: 'listado de detalles',
        nl: 'Lijst details'
      },
      amentiesFeatures: {
        en: 'Amenities and Features',
        fr: 'Commodités et fonctionnalités',
        es: 'Servicios y características',
        nl: 'Voorzieningen en functies'
      },
      id: {
        en: 'Property Id',
        fr: 'Identifiant de la propriété',
        es: 'Identificación de propiedad',
        nl: 'Property-ID'
      },
      type: {
        en: 'Property Type',
        fr: 'Type de propriété',
        es: 'tipo de propiedad',
        nl: 'Eigendom type'
      },
      price: {
        en: 'Listing Price',
        fr: "Prix d'inscription",
        es: 'Precio de listado',
        nl: 'Aanbiedingsprijs'
      },
      bedrooms: {
        en: 'Bedrooms',
        fr: 'Chambres',
        es: 'Dormitorios',
        nl: 'Slaapkamers'
      },
      baths: {
        en: 'Full baths',
        fr: 'Bains complets',
        es: 'Baños completos',
        nl: 'Volledige baden'
      },
      estateTitle: {
        en: 'About',
        fr: 'À propos',
        es: 'Acerca de',
        nl: 'Over'
      },
      realEstateAmenitiesButton: {
        en: 'SHOW ALL Details, Amenities and Features',
        fr: 'AFFICHER TOUS Détails, commodités et caractéristiques',
        es: 'MOSTRAR TODOS Los detalles, comodidades y características',
        nl: 'TOON ALLE details, voorzieningen en kenmerken'
      },
      collapse: {
        en: 'collapse all AMENITIES AVAILABLE TO YOU',
        fr: 'réduire toutes les COMMODITÉS À VOTRE DISPOSITION',
        es: 'colapsar todas LAS AMENIDADES DISPONIBLES PARA USTED',
        nl: 'samenvouwen van alle VOORZIENINGEN DIE VOOR U BESCHIKBAAR ZIJN'
      },
      show: {
        en: 'SHOW ALL',
        fr: 'AFFICHER TOUT',
        es: 'MOSTRAR TODO',
        nl: 'TOON ALLES'
      },
      amenties: {
        en: 'AMENITIES AVAILABLE TO YOU',
        fr: 'COMMODITÉS À VOTRE DISPOSITION',
        es: 'AMENIDADES DISPONIBLES PARA USTED',
        nl: 'VOORZIENINGEN DIE VOOR U BESCHIKBAAR ZIJN'
      },
      download: {
        en: 'Download Amenities',
        fr: 'Télécharger les commodités',
        es: 'Descargar Servicios',
        nl: 'Voorzieningen downloaden'
      }
    },
    availability: {
      title: {
        en: 'Availability',
        fr: 'Disponibilité',
        es: 'Disponibilidad',
        nl: 'Beschikbaarheid'
      },
      note: {
        en: 'Add your travel dates for exact pricing.',
        fr: 'Ajoutez vos dates de voyage pour obtenir les prix exacts.',
        es: 'Agregue las fechas de su viaje para conocer el precio exacto.',
        nl: 'Voeg uw reisdata toe voor exacte prijzen.'
      },
      subscribe: {
        en: 'Subscribe to iCal',
        fr: 'Abonnez-vous à iCal',
        es: 'Suscríbete a iCal',
        nl: 'Abonneer u op iCal'
      },
      clear: {
        en: 'Clear',
        fr: 'Clair',
        es: 'Claro',
        nl: 'Duidelijk'
      },
      clearDates: {
        en: 'Clear the Dates',
        fr: 'Effacer les dates',
        es: 'Borrar las fechas',
        nl: 'Wis de datums'
      },
      skip: {
        en: 'Skip to',
        fr: 'suivant',
        es: 'Pasemos a',
        nl: 'Ga naar'
      }
    },
    reviews: {
      title: {
        en: 'Unrivaled lifestyles <br /> Unforgettable Memories',
        fr: 'Des modes de vie inégalés<br /> Souvenirs inoubliables',
        es: 'Estilos de vida inigualables<br /> Memorias inolvidables',
        nl: 'Ongeëvenaarde levensstijl<br /> Onvergetelijke herinneringen'
      },
      button: {
        en: 'Load More Reviews',
        fr: "Charger plus d'avis",
        es: 'Cargar más reseñas',
        nl: 'Laad meer recensies'
      }
    },
    bonuses: {
      label: {
        en: 'VACATION RENTALS IN ST. MARTIN / VACATION RENTALS IN ST. MAARTEN',
        fr: 'LOCATIONS SAISONNIÈRES À SAINT. MARTIN / LOCATIONS SAISONNIÈRES À ST. MARTIN',
        es: 'ALQUILERES DE VACACIONES EN ST. MARTIN / ALQUILERES DE VACACIONES EN ST. MARTIN',
        nl: 'VAKANTIEWONINGEN IN ST. MARTIN / VAKANTIEWONINGEN IN ST. MAARTEN'
      },
      title: {
        en: 'Your stay is tailored to your wishes',
        fr: 'Votre séjour est adapté à vos souhaits',
        es: 'Su estancia se adapta a sus deseos',
        nl: 'Uw verblijf wordt afgestemd op uw wensen'
      }
    },
    rentals: {
      title: {
        en: 'Continue Your Search',
        fr: 'Continuez votre recherche',
        es: 'Continúe su búsqueda',
        nl: 'Ga door met zoeken'
      },
      button: {
        en: 'view all',
        fr: 'Voir tout',
        es: 'ver todo',
        nl: 'Bekijk alles'
      }
    }
  }
  return translationData
}

export default singlePropertyTranslations
